import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {Input, InputGroup, InputGroupAddon} from 'reactstrap';
import FaSearch from 'react-icons/lib/fa/search';

class FaSearchIcon extends Component {
  render() {
    return React.createElement('h3', null, React.createElement(FaSearch, null));
  }
}

//Export into own Component so it can be wrapped withRouter and testing is easier
class InputNav extends Component {
  render() {
    return (
      <InputGroup>
        <Input
          className="Search"
          value={this.props.searchValue}
          onChange={e => {
            this.props.update(e, this.props.history);
          }}
          onKeyPress={e => {
            this.props.update(e, this.props.history);
          }}
          placeholder="Search"
        />
        <InputGroupAddon addonType="append">
          <button
            onClick={e => {
              this.props.update(e, this.props.history);
            }}>
            <FaSearchIcon />{' '}
          </button>
        </InputGroupAddon>
      </InputGroup>
    );
  }
}

export default withRouter(InputNav);



// WEBPACK FOOTER //
// ./src/components/InputNav.js